const QUESTION_MARK = '?';
const LOCALE_REGX = /^\/[a-z]+/;

export const removeQueryStr = path => path.split(QUESTION_MARK)[0];

export const getHostName = hostname => hostname;

export const getPathWithoutLocale = path => path.replace(LOCALE_REGX, '');
